import { useEffect, useRef } from 'react'

import { Callback } from 'types/utils'

const useInterval = <T, R>(callback: Callback<T, R>, delay: number): void => {
  const savedCallbackRef = useRef<Callback<T, R>>(() => {})

  useEffect(() => {
    savedCallbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const handler: Callback<T, R> = (...args) =>
      savedCallbackRef.current(...args)

    if (delay !== null) {
      const intervalId = setInterval(handler, delay)
      return () => clearInterval(intervalId)
    }
  }, [delay])
}

export default useInterval
